class PasswordReveal extends HTMLElement {
  constructor() {
    super();
    this._targetInput = null;
    this._isRevealed = false;
  }
  connectedCallback() {
    // Find target input using data-target attribute or sibling input
    this._initializeTargetInput();

    // Add click event listener
    this.addEventListener('click', this._togglePasswordVisibility.bind(this));

    // Add keyboard event listener for accessibility
    this.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this._togglePasswordVisibility();
      }
    });
  }
  disconnectedCallback() {
    // Clean up event listeners
    this.removeEventListener('click', this._togglePasswordVisibility.bind(this));
    this.removeEventListener('keydown', this._handleKeydown);
  }
  _initializeTargetInput() {
    const targetId = this.getAttribute('data-target');
    if (targetId) {
      // Try to find by ID first
      this._targetInput = document.getElementById(targetId);
    }

    // If no target found by ID, try to find sibling input
    if (!this._targetInput) {
      // Look for a sibling input element of type password
      const parentElement = this.parentElement;
      if (parentElement) {
        this._targetInput = parentElement.querySelector('input[type="password"]');
      }
    }

    // Initialize state
    this._isRevealed = false;
  }
  _togglePasswordVisibility() {
    if (!this._targetInput) {
      console.error('PasswordReveal: No target input found');
      return;
    }

    // Toggle between password and text
    this._isRevealed = !this._isRevealed;

    // Update input type
    this._targetInput.type = this._isRevealed ? 'text' : 'password';

    // Update accessible state
    this.setAttribute('aria-pressed', this._isRevealed ? 'true' : 'false');

    // Update the visual state (you could add a class for styling)
    if (this._isRevealed) {
      this.classList.add('is-revealed');
    } else {
      this.classList.remove('is-revealed');
    }
  }
}
customElements.define('password-reveal', PasswordReveal);